if (!customElements.get('product-form')) {

  var item;

  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }


    onSubmitHandler(evt) {
      evt.preventDefault();

      console.log('Adding');
      $(".mini-cart-counter-circle").addClass("pulsating-cart");

      let is_boost = false;
      if (this.closest('.boost-pfs-filter-product-item')) {
        is_boost = true;
      }

      let is_pdp = false;
      if (this.closest('.single-add-to-cart-btn')) {
        is_pdp = true;
      }

      let is_pp = false;
      if (this.classList.contains('pp-item__buttons')) {
        is_pp = true;
      }
      console.log('is_pp: ' + is_pp);

      if (is_boost) {
        this.closest('.boost-pfs-filter-product-item').classList.add('boost-pfs-adding');
        this.querySelector('.boost-pfs-addtocart-btn-text').textContent = 'Adding...';


        /* Set Klaviyo Data */
        let boostForm = this.form;

        item = {
           Name: boostForm.querySelector('input[name="kl_name"]').value,
           ProductID: boostForm.querySelector('input[name="kl_id"]').value,
           Categories: boostForm.querySelector('input[name="kl_cat"]').value,
           ImageURL: boostForm.querySelector('input[name="kl_imgurl"]').value,
           URL: boostForm.querySelector('input[name="kl_url"]').value,
           Brand: boostForm.querySelector('input[name="kl_brand"]').value,
           Price: boostForm.querySelector('input[name="kl_price"]').value,
           CompareAtPrice: boostForm.querySelector('input[name="kl_compareatprice"]').value,
         };

         //console.log(item);
         
      } else if (is_pdp) { // Assume product page, so swap Add button with QTY selectors
          // Get the Product ID
          let productID = this.form.closest('product-form').getAttribute('data-id');
          console.log('Adding to cart: ' + productID);

          // Find any product page items of the same ID and reset.
          const productForm = document.querySelector(`.unero-single-product-detail product-form[data-id='${productID}']`);
          const productQtyInput = document.querySelector(`.unero-single-product-detail .product-form__input[data-id='${productID}']`);
          productForm.classList.add("hide");
          productQtyInput.classList.remove("hide");

      } else if (is_pp) { // Assume prev purchased page
          // Get the Product ID
          let productID = this.form.closest('product-form').getAttribute('data-id');
          console.log('Adding to cart: ' + productID);

          // disable all button elements on the page within a product-form element by setting pointer-events to none
          const buttonsToDisable = document.querySelectorAll(`product-form[data-id] button`);
          buttonsToDisable.forEach((button) => {
            button.setAttribute('disabled', true);
            button.style.pointerEvents = 'none';
            button.style.cursor = 'not-allowed';
          });

      }


      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      /* this.querySelector('.loading-overlay__spinner').classList.remove('hidden'); */

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            //window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          /* this.querySelector('.loading-overlay__spinner').classList.add('hidden'); */

          if (is_pp) { 

            let productID = this.form.closest('product-form').getAttribute('data-id');
            const productForms = document.querySelectorAll(`product-form[data-id='${productID}'] .pp-item__add-to-cart`);
            const productQtyInputs = document.querySelectorAll(`product-form[data-id='${productID}'] .pp-item__quantity`);

            productForms.forEach((productForm) => {
                productForm.classList.add("hide");
            });

            productQtyInputs.forEach((productQtyInput) => {
                productQtyInput.classList.remove("hide");
            });

            const ppItems = document.querySelectorAll(`.pp-item[data-product-id='${productID}'] `);
            ppItems.forEach((ppItem) => {
                ppItem.classList.add('is--in-cart');
            });

            // reenable buttons
            const buttonsToEnable = document.querySelectorAll(`product-form[data-id] button`);
            buttonsToEnable.forEach((button) => {
              button.removeAttribute('disabled');
              button.style.pointerEvents = 'auto';
              button.style.cursor = 'pointer';
            });
          }

          if (is_boost) {
            this.querySelector('.boost-pfs-addtocart-btn-text').textContent = 'Added';

            setTimeout(function() {
              this.querySelector('.boost-pfs-addtocart-btn-text').textContent = 'Add to Parcel';
            }.bind(this), 100)

            setTimeout(function() {
                this.closest('.boost-pfs-filter-product-item').classList.remove('boost-pfs-adding');
                this.closest('.boost-pfs-filter-product-item').classList.add('boost-pfs-added');
                //console.log('class changes')
            }.bind(this), 100)
          }

          setTimeout((function() {
              $(".mini-cart-counter-circle").removeClass("pulsating-cart")
          }), 100)

        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
